<template>
    <section class="filter">
        <div class="filter__container">
            <form id="filter__form form" class="filter__form form" >
                <div class="filter-container">
                    <select class="filter-new" id="filter-education-level" @change="onChangeSelectedLevel($event)" v-model="selectOptionLevel" :disabled="String(inputPrepodSurname).length > 0">
                        <option :value="null" disabled selected>Уровень образования</option>
                        <option value="1">Бакалавриат</option>
                        <option value="2">Магистратура</option>
                        <option value="3">Сипециалитет</option>
                    </select>
                    <select class="filter-new" id="filter-education-form" @change="onChangeSelectedForm($event)" v-model="selectOptionForm" :disabled="String(inputPrepodSurname).length > 0">
                        <option :value="null" disabled selected>Форма обучения</option>
                        <option value="1">Очная</option>
                        <option value="2">Очно-заочная</option>
                    </select>
                    <select class="filter-new" id="filter-course" @change="onChangeSelectedKurs($event)" v-model="selectOptionKurs" :disabled="String(inputPrepodSurname).length > 0">
                        <option :value="null" disabled selected>Курс</option>
                        <option value="1">1 курс</option>
                        <option value="2">2 курс</option>
                        <option value="3" v-show="Number(selectedLevel) !== 2">3 курс</option>
                        <option value="4" v-show="Number(selectedLevel) !== 2">4 курс</option>
                        <option value="5" v-show="Number(selectedLevel) !== 2 && Number(selectedLevel) !== 1">5 курс</option>
                        <option value="6" v-show="Number(selectedLevel) !== 2 && Number(selectedLevel) !== 1">6 курс</option>
                    </select>
                    <input type="text" class="filter-new" id="filter-group-number" placeholder="Номер группы" :value="inputGroupName" @input="set({inputGroupName: $event.target.value})" :disabled="String(inputPrepodSurname).length > 0">
                    <input type="text" class="filter-new" id="filter-prepod-surname" placeholder="Преподаватель" :value="inputPrepodSurname" @input="set({inputPrepodSurname: $event.target.value})" :disabled="Number(selectedLevel) > 0 || Number(selectedForm) > 0 || Number(selectedKurs) > 0 || String(inputGroupName).length > 0">
                    <button class="clear-btn-new" id="filter-clear-btn" @click.prevent=" clearForm()">Очистить</button>
                </div>
            </form>
        </div>
        <hr class="section__line"/>
    </section>
</template>
<script>

import {mapState, mapMutations} from "vuex";
export default{
    data:()=>({
        educationLevelShow: false,
        educationFormShow: false,
        selectedKursShow: false,
        selectOptionLevel: null,
        selectOptionForm: null,
        selectOptionKurs: null
    }),
    computed: {
        ...mapState(['selectedLevel', 'selectedForm', 'selectedKurs', 'inputGroupName', 'inputPrepodSurname']),
    },
    methods:{
        ...mapMutations(['set']),
        clearForm(){
            this.set({selectedLevel: 0, selectedForm: 0, selectedKurs: 0, inputGroupName: '', inputPrepodSurname: ''})
            this.selectOptionLevel = null;
            this.selectOptionForm = null;
            this.selectOptionKurs = null;
        },
        onChangeSelectedLevel(e){
            this.set({selectedLevel: e.target.value})
        },
        onChangeSelectedForm(e){
            this.set({selectedForm: e.target.value})
        },
        onChangeSelectedKurs(e){
            this.set({selectedKurs: e.target.value})
        }
    },
    watch:{
        educationLevelShow(){
            if(this.educationLevelShow){
                window.addEventListener("click", () => {
                    this.educationLevelShow = false
                })
                this.educationFormShow = false
                this.selectedKursShow = false
            }
        },
        educationFormShow(){
            if(this.educationFormShow){
                window.addEventListener("click", () => {
                    this.educationFormShow = false
                })
                this.educationLevelShow = false
                this.selectedKursShow = false
            }
        },
        selectedKursShow(){
            if(this.selectedKursShow){
                window.addEventListener("click",() => {
                    this.selectedKursShow = false
                })
                this.educationLevelShow = false
                this.educationFormShow = false
            } 
        },
    },
}
</script>
